"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var editableAreaPaddingPx = 24;
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        display: 'grid',
        gridTemplateRows: 'min-content auto min-content',
        backgroundColor: 'white',
        borderRadius: 4,
        padding: 8,
        height: '100%',
        width: '100%',
        overflow: 'auto',
    },
    editable: {
        backgroundColor: theme_1.default.colors.globalBackgroundLight,
        padding: editableAreaPaddingPx,
        borderRadius: 4,
        border: theme_1.default.borders.primary,
        cursor: 'text',
        overflow: 'auto',
        // These three are important to prevent editor from going into infinite width
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
    },
    lists: {
        // Reset margins on lists
        '& ul, & ol': {
            margin: 0,
            padding: "0px 0px 0px ".concat(editableAreaPaddingPx, "px"),
        },
    },
}));
